'use strict';

import reCaptcha from './reCaptcha.js';

var $btnFormSubmit = document.getElementById('js-btn-form-submit');
var $inputName = document.getElementById('name');
var $inputEmail = document.getElementById('email');
var $inputComment = document.getElementById('message');
var $inputPhone = document.getElementById('phone');
const $reCaptchaField = $('.js-recaptcha-token');
const form = document.getElementById('contact-us-form');

// Functions
function validateText(el) {
    if (el.value.length) {
        el.classList.remove('error');
        return true;
    } else {
        el.classList.add('error');
        return false;
    }
}
function validatePhone(el) {
    var res = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/im;
    if (res.test(el.value)) {
        el.classList.remove('error');
        return true;
    } else if (!res.test(el.value) || el.value == '') {
        el.classList.add('error');
        return false;
    }
    else if (el.value.length == 0) {
        el.classList.add('error');
        return false;
    }
}
function validateEmail(el) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(el.value)) {
        el.classList.remove('error');
        return true;
    } else {
        el.classList.add('error');
        return false;
    }
}

function validateCaptcha(token) {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: $reCaptchaField.data('validate-url'),
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                token: token
            })
        })
        .done((response) => {
            resolve(response); // Resolve the promise with the response
        })
        .fail(() => {
            reject(false); // Reject the promise with false
        });
    });
}

function initEvents() {
    $inputName.addEventListener('blur', function () {
        if (!validateText(this)) {
            this.value = '';
        }
    }, false);

    $inputName.addEventListener('keyup', function () {
        validateText(this);
    }, false);

    $inputPhone.addEventListener('blur', function () {
        if (!validatePhone(this)) {
            this.value = '';
        }
    }, false);

    $inputPhone.addEventListener('keyup', function () {
        validatePhone(this);
    }, false);

    $inputComment.addEventListener('blur', function () {
        if (!validateText(this)) {
            this.value = '';
        }
    }, false);

    $inputComment.addEventListener('keyup', function () {
        validateText(this);
    }, false);

    $inputEmail.addEventListener('blur', function () {
        if (!validateEmail(this)) {
            this.value = '';
        }
    }, false);

    $inputEmail.addEventListener('keyup', function () {
        validateEmail(this);
    }, false);

    $btnFormSubmit.addEventListener('click', async function (e) {
        e.preventDefault();

        try {
            const captchaToken = await reCaptcha.formSubmit();
            if (!captchaToken) {
                return false;
            }

            const validationCaptchaResponse = await validateCaptcha(captchaToken);
            if (
                !validationCaptchaResponse ||
                !validationCaptchaResponse.success
            ) {
                return false;
            }

            if (
                validateText($inputName) &&
                validateText($inputComment) &&
                validateEmail($inputEmail) &&
                validatePhone($inputPhone)
            ) {
                // invalid fields, prevent form submit
                return form.submit();
            }
            console.log('success');
        } catch (error) {
            console.log(error);
        }
    }, false);
}

export default {
    'init': () => {
        initEvents();
    }
};
